(ns ui.data.view-entities.sub
  (:require
   [re-frame.core :as rf]))

(def root-path [:ui.data/views])

(defn- scope-path
  [view-id scope-id]
  (into root-path (concat view-id [:scopes scope-id])))

(defn- status-path
  [view-id scope-id]
  (conj (scope-path view-id scope-id) :status))

(defn- entities-by-id-path
  [view-id scope-id]
  (conj (scope-path view-id scope-id) :entities/by-id))

(defn- root-entity-id-path
  [view-id scope-id]
  (conj (scope-path view-id scope-id) :config :entity-id))

(rf/reg-sub
 ::scope-status
 (fn [db [_ view-id scope-id]]
   (or (get-in db (status-path view-id scope-id))
       {:loading? true
        :error nil})))

(rf/reg-sub
 ::scope-entities-by-id
 (fn [db [_ view-id scope-id]]
   (or (get-in db (entities-by-id-path view-id scope-id))
       {})))

(rf/reg-sub
 ::scope-entity
 (fn [[_ view-id scope-id _entity-id]]
   [(rf/subscribe [::scope-entities-by-id view-id scope-id])
    (rf/subscribe [::scope-root-entity-id view-id scope-id])])
 (fn [[entities-by-id root-entity-id] [_ _ _ entity-id]]
   (let [entity-id (or entity-id root-entity-id)]
     (get entities-by-id entity-id))))

(rf/reg-sub
 ::scope-root-entity-id
 (fn [db [_ view-id scope-id]]
   (get-in db (root-entity-id-path view-id scope-id))))

(rf/reg-sub
 ::scope-root-entity
 (fn [[_ view-id scope-id]]
   [(rf/subscribe [::scope-entities-by-id view-id scope-id])
    (rf/subscribe [::scope-root-entity-id view-id scope-id])])
 (fn [[entities-by-id root-entity-id] _]
   (get entities-by-id root-entity-id)))
